import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useToastNotificationStore } from '../../toastNotification/ToastNotificationStore';
import { getToastNotificationData } from '../../toastNotification/services/toastNotificationDataService';

/**
 * @typedef {object} NotificationMessageProps
 * @property {number} notificationType
 * @property {Object} notificationData
 */

/**
 * @param {NotificationMessageProps} props
 */
export const NotificationMessage = props => {
  const { notificationType, notificationData } = props;
  const { message, url, state, storeField } = getToastNotificationData(
    notificationType,
    notificationData
  );

  const setToastNotificationStore = useToastNotificationStore.getState().setToastNotificationStore;

  const navigate = useNavigate();

  const handleClick = e => {
    e.preventDefault();

    if (storeField) {
      setToastNotificationStore(storeField, state);
    }

    navigate(url);
  };

  return (
    <>
      {url ? (
        <a href='#' onClick={handleClick}>
          {message}
        </a>
      ) : (
        message
      )}
    </>
  );
};
